<template>
  <v-dialog v-model="resetPwdDialog" max-width="600px" persistent>
    <v-card>
      <v-system-bar color="primary" dark>
        <v-spacer></v-spacer>
        <v-icon @click="close">close</v-icon>
      </v-system-bar>

      <v-card-title>
        <span class="headline">Alterar senha</span>
      </v-card-title>

      <v-card-text>
        <v-form ref="changePwdForm" v-model="validForm" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="formData.email"
                  label="E-mail"
                  :rules="$store.state.formRules.emailRules"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="formData.password_old"
                  label="Senha atual"
                  :rules="[rulesPass.required, rulesPass.min]"
                  required
                  :append-icon="show1 ? 'visibility' : 'visibility_off'"
                  :type="show1 ? 'text' : 'password'"
                  @click:append="show1 = !show1"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="formData.password_new"
                  label="Nova senha"
                  :rules="[rulesPass.required, rulesPass.min]"
                  required
                  :append-icon="show2 ? 'visibility' : 'visibility_off'"
                  :type="show2 ? 'text' : 'password'"
                  @click:append="show2 = !show2"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="formData.confirmPwd"
                  label="Confirme a nova senha"
                  :rules="[rulesPass.matchPass]"
                  required
                  :append-icon="show3 ? 'visibility' : 'visibility_off'"
                  :type="show3 ? 'text' : 'password'"
                  @click:append="show3 = !show3"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blueGrey darken-1" flat @click="close">Cancelar</v-btn>
        <v-btn color="primary" flat @click="save">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    resetPwdDialog: Boolean,
    closeDialog: Function
  },

  data () {
    let fixData = {
      show1: false,
      show2: false,
      show3: false,
      confirmPass: '',
      formData: {
        user_id: null,
        email: null,
        password_old: null,
        password_new: null,
        confirmPwd: null
      },
      validForm: true,
      rulesPass: {
        required: (value) => !!value || 'Não pode ser vazio.',
        min: (v) => (v && v.length >= 8) || 'Mínimo 8 caracters',
        matchPass: (v) =>
          (v && v === this.formData.password_new) || 'A senha não confere'
      }
    }

    return fixData
  },

  mounted () {
    this.formData.user_id = JSON.parse(localStorage.getItem('userData')).user_id
  },

  methods: {
    close () {
      this.closeDialog()
    },

    save () {
      if (!this.$refs.changePwdForm.validate()) {
        return
      }

      let obj = {
        url: '/api/alter/password',
        query: this.formData,
        method: 'post'
      }

      this.$store.dispatch('request/doRequest', obj).then((response) => {
        if (!response) {
          return
        }

        let opts = {
          message: `Senha alterada com sucesso`,
          type: 'success'
        }

        this.$store.commit('showAlert', opts)
        this.close()
      })
    }
  }
}
</script>

<style>
</style>
